// extracted by mini-css-extract-plugin
export default {"stepNavigation":"LoanConfigurationStep_stepNavigation__xNSev","approvalRequiredSelect":"LoanConfigurationStep_approvalRequiredSelect__8fRbz"};